import { Select } from "antd";
import { useDataTableEditableColumn } from "~components/DataTable/hooks/useDataTableEditableColumn.ts";

type Option = {
  value: string | null;
  label: string;
};

type Props = {
  value?: string | null;
  isEditMode: boolean;
  disabled?: boolean;
  options: Array<Option>;
  formatValue?: (value: string) => string;
  onSave?: (value: string | null) => void | Promise<void>;
};

const getInitialValue = (value?: string | null) => value ?? null;
const isEmpty = (value: string | null) => value === null;

export const DataTableSelectColumn = ({ value, isEditMode, disabled = false, options, formatValue, onSave }: Props) => {
  const { inputValue, loading, handleSave } = useDataTableEditableColumn({
    value,
    onSave,
    isEmpty,
    getInitialValue,
  });

  if (!isEditMode) {
    if (!value) {
      return "";
    }
    return formatValue ? formatValue(value) : value;
  }

  return (
    <Select
      disabled={disabled || loading}
      style={{ width: "100%" }}
      value={inputValue}
      options={options}
      onSelect={(nextValue: string | null) => void handleSave(nextValue)}
    />
  );
};
